import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { useTemplating } from '../../hooks/index';

const ExternalStateSync = ({ externalValue, setExternalValue }) => {
  const {
    dispatch,
    TYPES,
    value: internalValue,
    wasInternalUpdate
  } = useTemplating();

  const lastSyncedValue = useRef(externalValue);

  // Sync internal to external
  useEffect(() => {
    if (
      wasInternalUpdate.current
      && internalValue !== lastSyncedValue.current
    ) {
      wasInternalUpdate.current = false;
      lastSyncedValue.current = internalValue;
      setExternalValue(internalValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalValue, setExternalValue]);

  // Sync external to internal
  useEffect(() => {
    if (externalValue !== lastSyncedValue.current) {
      lastSyncedValue.current = externalValue;
      dispatch({
        type: TYPES.UPDATE_VALUE,
        value: externalValue
      });
    }
  }, [externalValue, dispatch, TYPES]);

  return null;
};

ExternalStateSync.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  externalValue: PropTypes.any.isRequired,
  setExternalValue: PropTypes.func.isRequired
};

export default ExternalStateSync;
